/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lift2': {
    width: 16,
    height: 16,
    viewBox: '0 0 21.66 21.17',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="#df4545"><path pid="0" d="M15.5 19.74H5.87a3.12 3.12 0 01-3.11-3.11V5.45a3.12 3.12 0 013.11-3.12h9.63a3.12 3.12 0 013.11 3.11v11.18a3.12 3.12 0 01-3.11 3.12zM5.87 3.33a2.12 2.12 0 00-2.12 2.12v11.17a2.12 2.12 0 002.11 2.11h9.64a2.12 2.12 0 002.11-2.11V5.45a2.12 2.12 0 00-2.11-2.12zM.5 21.17a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v20.17a.5.5 0 01-.5.5zM21.16 21.17a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v20.17a.5.5 0 01-.5.5z"/><path pid="1" d="M10.68 19.74a.5.5 0 01-.5-.5V2.83a.5.5 0 011 0v16.4a.5.5 0 01-.5.51z"/></g></g>'
  }
})
